export default __webpack_public_path__ + "static/media/edit-dark.15a3d195.svg";